import {Component, Input, OnInit} from '@angular/core';
import {saveAs} from 'file-saver';

@Component({
  selector: 'fx-save-image',
  templateUrl: './save-image.component.html',
  styleUrls: ['./save-image.component.sass']
})
export class SaveImageComponent implements OnInit {
  @Input() data;
  @Input() name;
  constructor() { }

  ngOnInit(): void {
  }

  convertBase64ToFile(url, fileName): any {
    const arr = (url).split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const uint8Array = new Uint8Array(n);
    while (n--) {
      uint8Array[n] = bstr.charCodeAt(n);
    }
    const file = new File([uint8Array], fileName, { type: mime });
    return file;
  }
  onSaveCapture(): void {
    const file = this.convertBase64ToFile(this.data, this.name);
    saveAs(file, this.name);
  }
}
